/**
 * Style tabs to align with design team specs.
 */
import TabsComp from '@material-ui/core/Tabs';
import {MOON_200, TEAL_550} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Tabs = styled(TabsComp)`
  box-shadow: inset 0 -2px 0 0 ${MOON_200};
  .MuiTabs-indicator {
    background-color: ${TEAL_550};
  }
`;
